import axios from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function storeProgramJobField (pFormdata) {
    const URI = `${BASE_URL}/api/programJobFields`
    return axios.post(URI, pFormdata, { headers })
}

function destroyProgramJobField (pIdProgramJobField) {
    const URI = `${BASE_URL}/api/programJobFields/${pIdProgramJobField}`
    return axios.delete(URI, { headers })
}

export {
    storeProgramJobField,
    destroyProgramJobField
}